import React, { useState, useEffect } from 'react';
import HeaderAdUnit from '../HeaderAdUnit/HeaderAdUnit.tsx';
import Sidebar from '../Sidebar/Sidebar.tsx';
import { SidebarProvider } from './SidebarContext.tsx';
import { getNumDaysSinceEpoch } from '../../utils/utils.js';
import { hasDismissedBanner, setBannerDismissed } from '../../utils/userStatsUtils.ts';

interface BaseContainerProps {
  children: React.ReactNode;
  header: React.ReactNode;
}

// Banner configuration: set start and end days (inclusive) and a unique id
const bannerConfig = {
  id: 'weaver-x-product-hunt',
  startDay: 20269, // set to your desired daysSinceEpoch
  endDay: 20270,   // set to your desired daysSinceEpoch (can be same as startDay for one day)
  content: (
    <>
      <a
        href="https://www.producthunt.com/posts/weaver-x"
        target="_blank"
        rel="noopener noreferrer"
        className="top-banner-link"
      >
        🚀 Upvote us on Product Hunt today!
      </a>
    </>
  ),
};

export default function BaseContainer(props: BaseContainerProps) {
  const { children, header } = props;

  // Calculate if the banner should show based on config and date
  const todayDaysSinceEpoch = getNumDaysSinceEpoch();
  const shouldShowTopBanner =
    todayDaysSinceEpoch >= bannerConfig.startDay &&
    todayDaysSinceEpoch <= bannerConfig.endDay;

  // Use state to trigger re-render after dismiss
  const [bannerDismissed, setBannerDismissedState] = useState(() => hasDismissedBanner(bannerConfig.id));

  useEffect(() => {
    document.documentElement.style.setProperty(
      '--top-banner-height',
      shouldShowTopBanner && !bannerDismissed ? '32px' : '0px'
    );
  }, [shouldShowTopBanner, bannerDismissed]);

  return (
    <SidebarProvider>
      <div id='game-container'>
        <HeaderAdUnit />
        {header}
        {shouldShowTopBanner && !bannerDismissed && (
          <div className="top-banner">
            {bannerConfig.content}
            <button
              className="close-banner"
              onClick={() => {
                setBannerDismissed(bannerConfig.id);
                setBannerDismissedState(true);
              }}
              aria-label="Close"
            >
              ×
            </button>
          </div>
        )}
        {children}
        <Sidebar />
      </div>
    </SidebarProvider>
  );
} 